export default () => ({
  field: {
    padding: '10px 15px',
  },
  container: {
    width: '100%',
    maxWidth: '1292px',
  },
});
